export default "__VITE_ASSET__eXcywyJb__"